export default __webpack_public_path__ + "static/assets/banner-bg.69532d2c.png";